import { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

export default function RequestAccountDeletionPage() {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [error, setError] = useState('');

    const validatePhone = (value) => {
        // Allow digits and common phone characters
        const cleaned = value.replace(/[^\d]/g, '');

        if (!value) {
            return 'Phone number is required';
        }

        if (cleaned.length < 10) {
            return 'Phone number must be at least 10 digits';
        }

        return '';
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setPhoneNumber(value);

        const validationError = validatePhone(value);
        setError(validationError);
    };

    const handleDeleteRequest = () => {
        const validationError = validatePhone(phoneNumber);

        if (validationError) {
            setError(validationError);
            return;
        }

        const confirmed = window.confirm('Are you sure you want to request account deletion?');

        if (confirmed) {
            setTimeout(() => {
                window.alert(
                    'Deletion has been scheduled. In case you change your mind, you can contact support at admin@zipzyride.com within 14 days to cancel the request.'
                );
                setPhoneNumber('');
            }, 3_500);
        }
    };

    const isDisabled = !!error || !phoneNumber;

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 3,
                px: 2,
            }}
        >
            <TextField
                label="Phone Number"
                variant="outlined"
                value={phoneNumber}
                onChange={handleChange}
                error={!!error}
                helperText={error}
                fullWidth
                sx={{ maxWidth: 360 }}
            />

            <Button
                type="button"
                variant="contained"
                color="error"
                onClick={handleDeleteRequest}
                disabled={isDisabled}
                sx={{ maxWidth: 360, width: '100%' }}
            >
                Request Account Deletion
            </Button>
        </Box>
    );
}
